var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_38_591)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3247 0.396622C12.6492 0.884394 9.3494 1.90256 6.52441 4.48155C0.913358 9.60401 -0.420956 18.29 3.4938 24.8496C4.66676 26.815 6.24089 28.4677 8.08497 29.7973C9.59109 30.8833 11.3492 31.686 13.1412 32.1447C15.1657 32.6628 17.251 32.8042 19.321 32.529C26.9493 31.5152 32.841 24.8903 33.1763 17.1523C33.5121 9.40205 27.9749 2.23549 20.4446 0.710525C19.1335 0.445006 17.6617 0.219194 16.3247 0.396622ZM18.5719 6.58159C21.726 6.5078 21.8008 11.2104 18.6343 11.2104C16.2168 11.2104 15.1785 7.92942 17.5107 6.82562C17.8419 6.66894 18.2064 6.59015 18.5719 6.58159ZM20.8191 24.2818C20.73 24.6016 20.7029 25.1389 20.4718 25.3852C20.1868 25.6889 19.5154 25.8033 19.1337 25.9489C17.556 26.5502 15.1552 26.8408 14.0754 25.165C13.6293 24.4726 13.6814 23.6753 13.7685 22.8937C13.9618 21.1594 14.6508 19.4719 15.0683 17.7833C15.2287 17.135 15.5323 16.1152 15.0979 15.5147C14.4937 14.6794 13.1529 15.1986 12.3921 15.4489C12.4352 15.1256 12.4877 14.5995 12.6951 14.3396C12.9632 14.0037 13.7448 13.8574 14.1399 13.7244C15.6454 13.2175 17.7813 12.8775 18.9228 14.3133C19.4588 14.9875 19.4533 15.7723 19.3888 16.5845C19.2521 18.3021 18.5565 19.9673 18.1429 21.6319C17.938 22.4562 17.4099 24.0197 18.4471 24.4929C19.234 24.852 20.0504 24.3965 20.8191 24.2818Z",
    fill: "#E30613"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.97762 24.382L0.190796 31.8774L10.0523 30.2827L3.97762 24.382Z",
    fill: "#E30613"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_38_591"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 32.3333,
    fill: "white",
    transform: "translate(0.190796 0.333473)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.c9c8a7d429ee7851ceac5349ef30952b.svg";
export { ForwardRef as ReactComponent };